import React, { Component } from 'react'
import './index.less'
interface GoodsItemProps {
  img: string
  title: string
  price: string
  vipPrice: string
  count: string
}
export default class GoodsItem extends Component<GoodsItemProps> {
  render() {
    let imgsrc = this.props.img.length > 0 ? this.props.img : '/public/assets/img/shopping_cart_logo.png'
    return (
      <div className='goods-item'>
        <img className='goods-img' src={imgsrc} alt="商品图" />
        <div className='goods-brief'>
          <span className='goods-item-title'>{this.props.title}</span>
          <s className='goods-price'>零售价：{this.props.price}元</s>
          <div className='goods-vip-count'>
            <span className='goods-vipprice'>会员价：{this.props.vipPrice}元</span>
            <span className='goods-item-count'>x{this.props.count}</span>
          </div>
        </div>
      </div>
    )
  }
}

